var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 51,
    viewBox: "0 0 78 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2733 17.2563C60.2027 16.5667 58.5016 15.9526 56.1437 15.9526C51.2079 15.9526 48.5217 19.4878 47.5808 23.9753C46.2409 30.3676 49.0996 33.0883 52.5494 33.0883C54.1504 33.0883 54.7825 32.6483 54.7825 32.6483L56.014 26.7027H52.2391L53.024 22.9294H62.0614L59.3226 35.8075C59.3226 35.8075 56.6741 36.9946 52.1192 36.9946C45.0078 36.9946 40.4628 31.4299 42.0834 23.7898C43.6942 16.1891 49.2146 12.0316 56.2028 12.0316C58.1782 12.0316 60.6428 12.3649 62.2848 13.1169L61.2733 17.2563ZM31.1216 36.4889H36.5434L41.5613 12.5751H36.1378L31.1216 36.4889ZM30.381 17.2563C29.0478 16.6193 27.166 16.0084 25.3237 16.0084C23.4404 16.0084 21.58 16.4436 21.2188 18.3187C20.8657 20.1495 22.511 21.2299 25.2564 22.7504C29.7095 25.2167 30.1085 28.077 29.5436 30.7666C28.6274 35.1457 24.6242 37.0242 19.9003 36.9749C15.4948 36.9289 12.426 35.4199 12.426 35.4199L13.4703 31.246C14.4784 31.8519 17.1992 33.0473 20.0382 33.0473C22.621 33.0473 23.7326 32.0785 24.0299 30.6549C24.4223 28.7831 23.5192 27.5877 20.984 26.1756C17.6048 24.2939 14.8988 22.2463 15.7099 18.3745C16.7263 13.5192 21.3042 12.0332 25.1694 12.0332C27.3581 12.0332 29.6323 12.3205 31.4615 13.0824L30.381 17.2563Z",
    fill: "#10238C",
    stroke: "#10238C",
    strokeWidth: 0.111655,
    strokeMiterlimit: 3.864
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0052 25.5008C77.0052 39.3066 59.8136 50.5 38.6074 50.5C17.3996 50.5 0.208008 39.3066 0.208008 25.5008C0.208008 11.6934 17.3996 0.5 38.6074 0.5C59.8136 0.5 77.0052 11.6934 77.0052 25.5008ZM38.6074 3.9104C19.1581 3.9104 3.39182 13.5767 3.39182 25.5008C3.39182 37.4233 19.1581 47.0896 38.6074 47.0896C58.0551 47.0896 73.8214 37.4233 73.8214 25.5008C73.8214 13.5767 58.0551 3.9104 38.6074 3.9104Z",
    fill: "#10238C",
    stroke: "#10238C",
    strokeWidth: 0.111655,
    strokeMiterlimit: 3.864
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSig);
export default __webpack_public_path__ + "static/media/sig.07cb03f2ed5597f838bb914f099d13ab.svg";
export { ForwardRef as ReactComponent };